import {
  FETCH_ALL_TRANSACTION_TYPES,
} from './../../mutation-types';

export default {
  [FETCH_ALL_TRANSACTION_TYPES](state, transactionTypes) {
    state.transactionTypes = transactionTypes;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/transactionType/mutations.js